import { render, staticRenderFns } from "./foroCard.vue?vue&type=template&id=1d88f552&scoped=true"
import script from "./foroCard.vue?vue&type=script&lang=js"
export * from "./foroCard.vue?vue&type=script&lang=js"
import style0 from "./foroCard.vue?vue&type=style&index=0&id=1d88f552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88f552",
  null
  
)

export default component.exports